const PDFDisplay = ({fileName}) => {
    const filePath = `${process.env.PUBLIC_URL}/pdfs/${fileName}`;

    return (
    <div className="pdf-container">
        <iframe 
        src={filePath} 
        width="100%" 
        height="100%" 
        title="PDF Viewer"
        style={{border: "none"}}>
        </iframe>
    </div>
    )
}

export default PDFDisplay